/**
 * `feature:storage_hns_action` (S8 «Pinned additions» → Analytics): ONE event per completed Data Lake path action with
 * enum properties only — never a path, name or object ID. `outcomeOfHnsError` maps a typed refusal to its enum.
 */
import type { StorageOperationError } from '../../../../types/azureStorage';
import { trackStorageEvent } from '../services/storageAnalytics';
import type { HnsActionSource } from './dialogs/hnsDialogTypes';

export type HnsActionName = 'create_directory' | 'rename' | 'move' | 'continue_move' | 'recheck_pending_move' | 'dismiss_pending_move' | 'copy_path';
export type HnsActionOutcome = 'ok' | 'partial' | 'uncertain' | 'conflict' | 'refused' | 'unavailable' | 'error' | 'cancelled' | 'ambiguous';

export function outcomeOfHnsError(error: StorageOperationError): HnsActionOutcome {
  switch (error.category) {
    case 'conflict':
      return 'conflict';
    case 'ambiguous_outcome':
      return 'ambiguous';
    case 'cancelled':
      return 'cancelled';
    case 'unsupported':
      return 'unavailable';
    case 'authorization':
    case 'invalid_input':
    case 'not_found':
      return 'refused';
    default:
      return 'error';
  }
}

export function trackHnsAction(action: HnsActionName, outcome: HnsActionOutcome, source: HnsActionSource): void {
  trackStorageEvent('feature:storage_hns_action', { action, outcome, source });
}
